import { Component } from '@angular/core';

@Component({
  selector: 'app-checked-email',
  templateUrl: './checked-email.component.html',
  styleUrls: ['./checked-email.component.css']
})
export class CheckedEmailComponent {

}
